var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState, } from 'react';
var ShellAuthContext = createContext(null);
/**
 * Provides shell-resolved auth data and permissions to a micro-frontend tree.
 * Accepts the authBridge from single-spa customProps and subscribes to updates.
 * Renders children once auth data exists; `permissions` may still be null until
 * the shell resolves them — apps should show loading UI as needed.
 *
 * Consumers use useShellAuth() to access the values.
 */
export var ShellAuthProvider = function (_a) {
    var authBridge = _a.authBridge, children = _a.children;
    var _b = __read(useState(authBridge.authData), 2), authData = _b[0], setAuthData = _b[1];
    var _c = __read(useState(authBridge.permissions), 2), permissions = _c[0], setPermissions = _c[1];
    useEffect(function () {
        var unsubscribe = authBridge.subscribe(function (state) {
            setAuthData(state.authData);
            setPermissions(state.permissions);
        });
        // Re-read current values in case a resolve fired between
        // the useState initializers and this subscription.
        setAuthData(authBridge.authData);
        setPermissions(authBridge.permissions);
        return unsubscribe;
    }, [authBridge]);
    if (!authData) {
        return null;
    }
    return (_jsx(ShellAuthContext.Provider, { value: __assign(__assign({}, authData), { permissions: permissions }), children: children }));
};
/**
 * Returns shell-resolved auth data and permissions. Must be called within a
 * ShellAuthProvider — throws if used outside one. `permissions` may be null
 * until the shell publishes them on the auth bridge.
 */
export var useShellAuth = function () {
    var ctx = useContext(ShellAuthContext);
    if (!ctx) {
        throw new Error('useShellAuth must be called within a ShellAuthProvider');
    }
    return ctx;
};
